import React from 'react';
import Loader from './Loader';

export default class PageLoader extends React.Component {
	render() {
		return (
      <div className="page-loader-container">
        <Loader loading/>
      </div>
		);
	}
}



// WEBPACK FOOTER //
// ./js/components/widgets/PageLoader.js